import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	filterAlertsTitle: {
		id: 'eoc-on-call.tours.routing-rule.filter-alerts-title',
		defaultMessage: 'Streamline routing',
		description: 'Title of filter alerts spotlight',
	},
	filterAlertsDescription: {
		id: 'eoc-on-call.tours.routing-rule.filter-alerts-description',
		defaultMessage:
			'Conditions make it easy to streamline routing for specific alerts. If you set no conditions, all the alerts will be routed.',
		description: 'Description of filter alerts spotlight',
	},
	timeRestrictionsTitle: {
		id: 'eoc-on-call.tours.routing-rule.time-restrictions-title',
		defaultMessage: 'Define time restrictions',
		description: 'Title of Time Restrictions spotlight',
	},
	timeRestrictionsDescription: {
		id: 'eoc-on-call.tours.routing-rule.time-restrictions-description',
		defaultMessage:
			'With time interval restrictions included in the rule, your alerts will be routed at the right time. Set up time restrictions for your business hours and off-hours, for instance.',
		description: 'Description of Time Restrictions spotlight',
	},
});
